import { Box, Text } from '@factorialco/deprecated-design-system'
import { RichTextDisplay } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import DropItem from 'modules/procurement/components/DropItem'

interface DownloadDocumentProps {
  content?: string | null
  files?: {
    id: number
    fileId: number
    byteSize: number
    contentType: string
    filename: string
    url: string
  }[]
  onFileDownload?: (fileId: number) => void
}

export const DownloadDocument = ({ content, files, onFileDownload }: DownloadDocumentProps) => {
  return (
    <Box gap="s12">
      <Text.Header3>
        {i18n.t('tasks.types.procurement_request_document.required_action_text_label')}
      </Text.Header3>
      {content && (
        <Box flexDirection="column" gap="s4">
          <RichTextDisplay content={content} className="text-f1-foreground-secondary" />
        </Box>
      )}

      {files && files.length > 0 && (
        <Box flexDirection="column" gap="s8">
          {files?.map((file) => (
            <DropItem
              key={file.fileId}
              file={file}
              onDownload={() => onFileDownload?.(file.fileId)}
            />
          ))}
        </Box>
      )}
    </Box>
  )
}
